import * as z from 'zod';
import { passwordValidator } from '@/lib/validators';

const SIGN_IN_FORM_CONFIG = {
  defaultValues: {
    companyEmail: '',
    password: '',
  },
  baseAttributes: {
    companyEmail: {
      required: true,
      label: 'Email',
      name: 'companyEmail',
      placeholder: '輸入公司 Email 帳戶（作為登入帳號）',
    },
    password: {
      required: true,
      label: '密碼',
      name: 'password',
      placeholder: '輸入密碼',
    },
  } as const,
  schema: z.object({
    companyEmail: z.string().min(1, { message: '請輸入公司 Email 帳戶（作為登入帳號）' }).email({
      message: '請輸入正確的 Email 格式',
    }),
    password: passwordValidator,
  }),
};

export default SIGN_IN_FORM_CONFIG;
